// extracted by mini-css-extract-plugin
export default {"features":"HomeFeatures_features__ndAsh","header":"HomeFeatures_header__G7QgB","content":"HomeFeatures_content__-Vv6c","block":"HomeFeatures_block__ffpCY"};